import { sideMenu, additionalPages } from "../../config/sideMenu";
import { FileText } from "lucide-react";
import React from "react";

export interface PageDetails {
  label: string;
  route: string;
  icon: React.ComponentType<any> | null;
}

export const getPageInfoFromPath = (
  currentPath: string,
): { currentPage: PageDetails | null } => {
  let currentPage: PageDetails | null = null;

  const allPages = [...sideMenu, ...additionalPages];

  for (const item of allPages) {
    if (
      item.route === currentPath ||
      (item.matchChildRoutes && currentPath.startsWith(item.route)) ||
      (item.route.includes(":id") &&
        currentPath.startsWith(item.route.split(":")[0]))
    ) {
      currentPage = item;
      break;
    }
    if (item.children) {
      const child = item.children.find(
        (child: any) => child.route === currentPath,
      );
      if (child) {
        currentPage = child;
        break;
      }
    }
  }

  if (
    !currentPage &&
    (currentPath.includes("/details/") || currentPath.includes("/info/"))
  ) {
    currentPage = {
      label: "Details",
      route: currentPath,
      icon: FileText,
    };
  }

  if (!currentPage) {
    const pathParts = currentPath.split("/").filter(Boolean);
    if (pathParts.length > 0) {
      let lastPart = pathParts[pathParts.length - 1];

      const lastHyphenIndex = lastPart.lastIndexOf("-");
      if (lastHyphenIndex !== -1) {
        const afterHyphen = lastPart.slice(lastHyphenIndex + 1);
        if (!isNaN(Number(afterHyphen))) {
          lastPart = lastPart.slice(0, lastHyphenIndex);
        }
      }

      const formattedLabel = lastPart
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      currentPage = {
        label: formattedLabel,
        route: currentPath,
        icon: null,
      };
    }
  }

  return { currentPage };
};
